(function ( $ ){

	var anzahl = 1;

	var defaults = {

		anzahl: anzahl,

		groessen: {
			vorschau: {
				bezeichnung: "Large Square",
				groesse: 150
			},
			foto: {
				bezeichnung: "Large",
				groesse: 1024
			},
			original: {
				bezeichnung: "Original",
				groesse: 0
			}
		},

		groesse: {
			bezeichnung: "Large",
			groesse: 1024
		},

		flickr: {
			per_page: anzahl,
			page: 1,
			sort: "date-posted-desc"
		}

	};


	$.fn.flickrFeed = function(options){

		var options = options || {};

		return this.each(function(){

			var kontext = $(this);


				/* Einstellungen über Data-Attribute */

			var data = {

				flickr: {
					user_id: kontext.data("user-id"),
					api_key: kontext.data("app-key"),
					per_page: kontext.data("count"),
					photoset_id: kontext.data("photoset-id")
				}

			}


				/* Einstellungen vereinen */

			var settings = $.extend({}, defaults, options, data);

			new Feed(kontext, settings);

		});

	};

	var Feed = function(kontext, settings){

		var self = this;

		this.kontext = kontext;
		this.settings = settings;

			// Bilder

		for (var index = 0; index < this.settings.anzahl; index++){
			$('<img alt=""/>').appendTo(kontext).data("index", index);
		}


		this.getFotos();

	}


	Feed.prototype.getFotos = function(){

		var self = this;

		var flickr = $.extend({}, this.settings.flickr, {
			method: 'flickr.photosets.getPhotos',
			format: 'json',
			jsoncallback: '?'
		});


		$.getJSON('https://api.flickr.com/services/rest/', getQueryString(flickr), function(daten){

			if (daten.stat == "ok"){

				var fotos = daten.photoset.photo;

				if (fotos.length === 0){
					zeigeFehler("Es wurden keine Bilder gefunden.");
				}

				for (var id = 0; id < flickr.per_page; id++){

					$('img', this.kontext).eq(id).data("source", "");

					if (id < fotos.length){
						self.getFoto(id, fotos[id]);
					} else {
							// Leeres Bild
						self.zeigeFoto(id);
					}

				}

			} else {
				zeigeFehler("Es wurden keine Daten empfangen. Bitte versuchen Sie es später noch einmal.");
			}

		});

	};

	Feed.prototype.getFoto = function(position, foto){

		var self = this;

		var flickr = $.extend({}, this.settings.flickr, {
			method: 'flickr.photos.getSizes',
			photo_id: foto.id,
			format: 'json',
			jsoncallback: '?'
		});

		$.getJSON('https://api.flickr.com/services/rest/', getQueryString(flickr), function(daten){

			if(daten.stat == "ok"){
				self.zeigeFoto(position, foto, daten.sizes);
			}

		});

	};

	Feed.prototype.zeigeFoto = function(position, foto, groessen){

		var bild = $("img", this.kontext).eq(position);

		bild.removeAttr("src").hide();

		if (typeof foto !== "undefined"){

			bild.data("source", "");

			for (var id in groessen.size){

				var size = groessen.size[id];

				if (size.label === this.settings.groesse.bezeichnung){
					bild.show().attr("src", size.source);
				}

			}

		}

	};

	var zeigeFehler = function(text){

		if (typeof console !== "undefined" && typeof console.log !== "undefined"){
			console.log("instagramFeed: " + text);
		}

	};

	var getQueryString = function(daten){

		var query = "";

		for (var id in daten){
			query += '&' + id + '=' + daten[id];
		}

		return query;

	};


}( jQuery ));